<!--缴费界面-->
<template>
<j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="close"
    :cancelText="$t('关闭')">
    <template slot="footer">
        <a-button key="close" @click="close">
          {{ $t('关闭') }}
        </a-button>
    </template>
  <div>
    <a-tabs v-model="activeKey" @change="changeTab">
      <a-tab-pane key="1" :tab="$t('用户卡充值')" >
        <div class="form-contain">
          <a-divider orientation="left">{{ $t('用户信息') }}</a-divider>
          <detail-list>
            <detail-list-item :term="$t('用户编号')">{{model.userId}}</detail-list-item>
            <detail-list-item :term="$t('用户姓名')">{{model.userName}}</detail-list-item>
            <detail-list-item :term="$t('手机号码')">{{model.userPhone}}</detail-list-item>
            <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
            <detail-list-item :term="$t('用水单价(元)')">{{userByKeyId.userPriceTotal}}</detail-list-item>
            <detail-list-item :term="$t('价格名称')">{{userByKeyId.userPriceName}}</detail-list-item>
            <detail-list-item :term="$t('单次最大购买金额(元)')">{{userByKeyId.maxBuyOnce}}</detail-list-item>
            <detail-list-item :term="$t('最大囤积金额(元)')">{{userByKeyId.maxHording}}</detail-list-item>
            <detail-list-item :term="$t('用户地址')">{{model.userAddr}}</detail-list-item>
          </detail-list>
          <div>
            <a-divider orientation="left">{{ $t('用户缴费信息') }}</a-divider>
            <a-form-model ref="form" :model="form" :rules="rules">
              <a-row :gutter="16">
                <a-col :span="8">
                  <a-form-item :label="$t('订单编号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="userByKeyId.orderId" style="width: 150%;" :readOnly="true" class="background"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-button type="primary" style="margin-left:100px;margin-top:5px;width:15%;" @click="Refresh()" :disabled="disabledRefreshOrderId">
                    {{ $t('刷新') }}
                  </a-button>
                </a-col>
              </a-row>
              <a-row :gutter="16">
                <a-col :span="12">
                  <a-form-model-item :label="$t('交易方式')" prop="payWay" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-radio-group  v-model="form.payWay">
                      <a-radio :value="1">
                        {{ $t('营业厅现金') }}
                      </a-radio>
                      <a-radio :value="2">
                        {{ $t('扫码支付') }}
                      </a-radio>
                      <a-radio :value="3">
                        {{ $t('对公转账') }}
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12" >
                  <a-form-model-item :label="$t('计费类型')" prop="payType" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-radio-group v-model="form.payType" @change="handleChange">
                      <a-radio :value="1">
                        {{ $t('按金额计算') }}
                      </a-radio>
                      <a-radio :value="2">
                        {{ $t('按吨数计算') }}
                      </a-radio>
                    </a-radio-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="16">
                <a-col :span="7">
                  <a-form-model-item :label="$t('用户当前余额(元)')">
                    <a-input v-model="userByKeyId.userAccountNum" :readOnly="true" class="background"></a-input>
                  </a-form-model-item>
                </a-col>
                <div v-if="thebillingtype==2">
                  <a-col :span="7" >
                    <a-form-model-item :label="$t('交易吨数(吨)')" prop="buyWaterCount">
                      <a-input v-model="form.buyWaterCount" @blur="buyWaterCount" :placeholder="$t('请输入交易吨数')"></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-model-item label=""> 
                    <a-button v-for="item in itemList" :key="item.key" type="primary"  plain="false"  @click="Capacity(item.value)" style="margin-left: 12px;margin-top: 44px;">
                    {{item.value}}t
                    </a-button>
                    </a-form-model-item>
                  </a-col>
                </div>
                <div v-if="thebillingtype==1">
                  <a-col :span="7" >
                    <a-form-model-item :label="$t('充值金额(元)')" required prop="userTotalPayNum">
                      <a-input v-model="form.userTotalPayNum" @change="userTotalPayNum" :placeholder="$t('请输入充值金额')"></a-input>
                    </a-form-model-item>
                  </a-col>
                  <a-col :span="7">
                    <a-form-model-item label=""> 
                    <a-button v-for="item in payList" :key="item.key" type="primary"  plain="false"  @click="amountofmoney(item.value)" style="margin-left: 12px;margin-top: 44px;">
                    ¥{{item.value}}
                    </a-button>
                    </a-form-model-item>
                  </a-col>
                </div>
              </a-row>
              <a-row :gutter="16">
                <a-col :span="7">
                  <a-form-model-item :label="$t('应收金额(元)')" prop="buyWaterMoney">
                    <a-input v-model="form.buyWaterMoney" :readOnly="true" class="background"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="7" v-if="thebillingtype==2">
                  <a-form-model-item :label="$t('实际付款(元)')" prop="userRealPay">
                    <a-input v-model="form.userRealPay" @blur="userRealPay" :placeholder="$t('请输入实际付款金额')"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="7" v-if="thebillingtype==1">
                  <a-form-model-item :label="$t('缴费备注')" prop="remark">
                    <a-input v-model="form.remark" :placeholder="$t('请输入缴费备注')"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="16">
                <a-col :span="7" v-if="thebillingtype==2">
                  <a-form-model-item :label="$t('用户找零(元)')" prop="userReturn">
                    <a-input v-model="form.userReturn" :readOnly="true" class="background"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="7" v-if="thebillingtype==2">
                  <a-form-model-item :label="$t('缴费备注')" prop="remark">
                    <a-input v-model="form.remark" :placeholder="$t('请输入缴费备注')"></a-input>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="7"></a-col>
                <a-col :span="8">
                  <a-button type="danger" block size="large" @click="recharge()">
                    {{ $t('充值') }}
                  </a-button>
                </a-col>
              </a-row>
              <!--
              <a-modal 
                v-model="note"
                :title="title"
                :width="800"
                switchFullscreen
                cancelText="关闭">
                <template slot="footer">
                    <a-button key="close" @click="handleCancel">
                      关闭
                    </a-button>
                </template>
                <a-card :bordered="false" :class="{'abcdefg':true}">
                  <div class="no-print" style="text-align: right">
                    <a-button v-print="'#printContent'" ghost type="primary">打印</a-button>
                  </div>
                  <section ref="print" id="printContent" class="abcdefg">
                    <div style="text-align: center">
                      <p style="font-size: 24px;font-weight: 800">水费收据</p>
                    </div>
                    <table border="1" id="table" width="700" >
                        <tr>
                          <td >地址</td>
                          <td colspan="3">{{model.userAddr}}</td>
                        </tr>
                        <tr>
                          <td>交易时间</td>
                          <td>{{flush.createTime}}</td>
                          <td>用户姓名</td>
                          <td>{{model.userName}}</td>
                        </tr>
                        <tr>
                          <td>价格名称</td>
                          <td>{{userByKeyId.userPriceName}}</td>
                          <td>用户编号</td>
                          <td>{{model.userId}}</td>
                        </tr>
                        <tr>
                          <td>水费单价(元)</td>
                          <td>{{userByKeyId.userPriceTotal}}</td>
                          <td>污水处理费(元)</td>
                          <td>0.85</td>
                        </tr>
                        <tr>
                          <td>水费合计(元)</td>
                          <td>0.78</td>
                          <td>污水处理费合计(元)</td>
                          <td>0.22</td>
                        </tr>
                        <tr>
                          <td>本次购买量(立方米)</td>
                          <td>0.26</td>
                          <td>本次购买金额(元)</td>
                          <td>1.00</td>
                        </tr>
                        <tr>
                          <td>操作员</td>
                          <td colspan="3">收费员:{{model.createBy}}&nbsp;&nbsp;打印员:{{nickname()}}&nbsp;&nbsp;打印时间:{{moment().format('YYYY-MM-DD HH:mm:ss')}}</td>
                        </tr>
                      </table>
                  </section>
                </a-card>
              </a-modal>
              -->
            </a-form-model>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="3" :tab="$t('充值记录')">
        <div class="form-contain">
          <a-table 
          :columns="columns"
          :data-source="data"
          rowKey='id'
          size='middle'
          :pagination="ipagination"
          @change="handleTableChange"
          />
        </div>
      </a-tab-pane>
    </a-tabs>
    <!--
    <a-modal v-model="CardInformation" centered title="确定要充值到用户卡吗?" @ok="CardInformationOk">
      <detail-list :col='2'>
        <detail-list-item term="用户编号">{{userdate.userId}}</detail-list-item>
        <detail-list-item term="购买次数">{{userdate.userPayTimes}}</detail-list-item>
        <detail-list-item term="剩余金额(元)">{{userdate.userAccountNum}}</detail-list-item>
        <detail-list-item term="累计用量(m³)" class="label">{{userdate.userWaterNum}}</detail-list-item>
        <detail-list-item term="单价(元)" class="label">{{userdate.wtTotalPrice}}</detail-list-item>
      </detail-list>
    </a-modal>
    -->
    <!--
    <a-modal v-model="TheUserDetails" :width="1100" switchFullscreen centered title="用户详细信息">
      <template slot="footer">
        <a-button key="close" @click="turnoff">
          关闭
        </a-button>
      </template>
      <div class="form-contain">
        <a-divider orientation="left" v-if="this.exhibition!=false">用户信息</a-divider>
          <detail-list v-if="this.exhibition!=false">
            <detail-list-item term="表编号">{{userdate.meterId}}</detail-list-item>
            <detail-list-item term="用户编号">{{userdate.userId}}</detail-list-item>
            <detail-list-item term="用户姓名">{{userdate.userName}}</detail-list-item>
            <detail-list-item term="手机号码">{{userdate.userPhone}}</detail-list-item>
            <detail-list-item term="表IMEI号">{{userdate.meterIMEI}}</detail-list-item>
            <detail-list-item term="用户地址">{{userdate.userAddr}}</detail-list-item>
            <detail-list-item term="用户所在区域名称">{{userdate.userAreaName}}</detail-list-item>
            <detail-list-item term="当前余额" class="label">{{userdate.userAccountNum}}元</detail-list-item>
            <detail-list-item term="充值次数">{{userdate.userPayTimes}}</detail-list-item>
            <detail-list-item term="当前表累计用量" class="label">{{userdate.userWaterNum}}m³</detail-list-item>
            <detail-list-item term="价格名称">{{userdate.wtName}}</detail-list-item> 
            <detail-list-item term="合计单价" class="label">{{userdate.wtTotalPrice}}元</detail-list-item>
            <detail-list-item term="用户是否制卡">{{userdate.userHasCard===null?'未制卡':userdate.userHasCard==1?'已制卡':userdate.userHasCard==0?'未制卡':''}}</detail-list-item> 
            <detail-list-item term="用户制卡时间" v-if="userdate.userHasCard==1">{{userdate.userCreateCardTime}}</detail-list-item>
          </detail-list>
          <a-row :gutter="24">
            <a-col :span="8"></a-col>
            <a-col :span="8" style="margin-top:25px">
              <a-button type="danger" block size="large" @click="CardInformation = true">
                用户卡充值
              </a-button>
            </a-col>
          </a-row>
      </div>
    </a-modal>
    -->
    <print-pay-note-modal ref="printPayNoteModal"></print-pay-note-modal>
  </div>
</j-modal>
</template>

<script>
  import { getAction,putAction,postAction } from '@/api/manage'
  import {isUndefined,isNull} from'@/utils/validate'
  import DetailList from '@/components/tools/DetailList'
  import moment from 'moment'
  import {payWayObj,payTypeObj} from '@/utils/constants/commonConstant'
  import { mapGetters } from 'vuex'
  import printPayNoteModal from '@/views/meterManagement/modules/printPayNoteModal'
  

  const DetailListItem = DetailList.Item
  const data = [];
  export default {
    name: 'MeterPayForm',
    components: {
      DetailList,
      DetailListItem,
      printPayNoteModal
    },
    Userinfolist:[],
    props: {
    },
    data () {
      const USB_DEF_INDEX = {
        // 开用户卡
        USB_DEF_MAKECARD : 60,
      }
      return {
        disableSubmit:false,
        width:1100,
        visible: false,
        data,
        activeKey:'1',
        flush:'',
        userByKeyId:{},
        userdate:{},
        Userinfolist:[],
        selectedRowKeys:[],
        USB_DEF_INDEX,
        wid:1001,
        note:false,
        CardInformation:false,
        TheUserDetails:false, //用户详细信息
        exhibition:false,
        model: {},
        form:{
          payType:1,
          payWay:1,
          buyWaterCount:'',
          userTotalPayNum:'',
          buyWaterMoney:'',
          userRealPay:'',
          remark:'',
          userReturn:'',
        },
        confirmLoading: false,
        ipagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " " + this.$t('共{total}条', { total: total })
          },
          total: 0
        },
        labelCol: { 
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        payList:[   //定义paylist列表
          {key:1, value:100 },
          {key:2, value:200},
          {key:3, value:500}
        ],
        itemList:[  //定义itemlist列表
          {key:1, value:10},
          {key:2, value:50},
          {key:3, value:100}
        ],
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          lists: "/jeecg-charge/meter/meterUserinfo/list",
          edit: "/jeecg-charge/meter/meterUserinfo/edit",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          doPayTask:"/jeecg-charge/meter/userPay/doPayTask",
          userByKeyId:"/jeecg-charge/meter/userPay/queryUserByKeyId",  //缴费前查询接口
          UserRecordList:"/jeecg-charge/meter/meterUserPayRecord/list", //缴费记录查询接口
          writeCard:"jeecg-charge/meter/meterCardWriteRecord/writeCard",
          getCardUserInfo:"jeecg-charge/meter/meterCardUpData/getCardUserInfo",  //用户制卡或写卡
        },
        thebillingtype: 1,
        realpay:0,
        socket: null,
        timeOutId: null,
        disabledRefreshOrderId: false
      }
    },
    computed: {
      // i18n：表格列/校验消息/标题使用 computed 以响应语言切换
      title () {
        return this.$t('卡充值')
      },
      columns () {
        return [
          {
            title: this.$t('用户姓名'),
            dataIndex: 'userName',
            key: 'userName',
            align: 'center'
          }, {
            title: this.$t('购买金额(元)'),
            dataIndex: 'userPayAccountNum',
            key: 'userPayAccountNum',
            align: 'center'
          }, {
            title: this.$t('缴费途径'),
            dataIndex: 'payWay',
            key: 'payWay',
            align: 'center',
            customRender: (t, r, index) => {
              if (isUndefined(payWayObj[t])) {
                return this.$t('其他')
              }
              return this.$t(payWayObj[t])
            }
          }, {
            title: this.$t('价格名称'),
            dataIndex: 'userPriceName',
            key: 'userPriceName',
            align: 'center'
          }, {
            title: this.$t('购买量(吨)'),
            dataIndex: 'payWaterNum',
            key: 'payWaterNum',
            align: 'center'
          }, {
            title: this.$t('订单号'),
            dataIndex: 'payOrderId',
            key: 'payOrderId',
            align: 'center'
          }, {
            title: this.$t('操作员'),
            dataIndex: 'createBy',
            key: 'createBy',
            align: 'center'
          }, {
            title: this.$t('充值日期'),
            dataIndex: 'createTime',
            key: 'createTime',
            align: 'center'
          }, {
            title: this.$t('操作类型'),
            dataIndex: 'userAccountPayType',
            key: 'userAccountPayType',
            align: 'center',
            customRender: (t, r, index) => {
              if (isUndefined(payTypeObj[t])) {
                return this.$t('其他')
              }
              return this.$t(payTypeObj[t])
            }
          }
        ]
      },
      rules () {
        return {
          buyWaterCount: [{ required: true, message: this.$t('请输入交易吨数')}], //交易吨数
          userTotalPayNum: [
            { required: true, message: this.$t('请输入充值金额')},
            { required: false, pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/, message: this.$t('充值金额输入有误，请重新输入')}
          ], //充值金额
          userRealPay: [
            { required: true, message: this.$t('请输入实际付款金额')},
            { required: false, pattern: /^((0{1}\.\d{1,2})|([1-9]\d*\.{1}\d{1,2})|([1-9]+\d*))$/, message: this.$t('实际付款金额输入有误，请重新输入')}
          ] // 实际付款金额
        }
      }
    },
    created () {
      // this.queryUserRecordList();
    },
    methods: {
      ...mapGetters(["nickname"]),
      //卡充值操作
      // 连接socket
      connWebsocket(){
        try{
          if(this.visible) {
            this.socket=new WebSocket('ws://127.0.0.1:8753');//复费率端口号为:8744
          }
        }catch(e){
          alert('error');
          return;
        }
        this.socket.onopen = this.sOpen;
        this.socket.onerror = this.sError;
        this.socket.onclose= this.sClose;
        this.socket.onmessage= this.sMessage; 
      },
      sOpen(){
        console.log("WebSocket连接成功");
        // this.$message.success("插件连接成功");
        this.bconn = true;
        // 注册页面
        this.usb_do_deal(this.wid, this.socket, this.USB_DEF_PAGEMARK,this.wid);
      },
      sError(e){
        console.log("WebSocket连接发生错误");
      },
      sMessage(msg) {
        console.log(msg);
        if (msg.data==2) {
          return
        }
        console.log(msg.data.split(","));
        if (msg.data.split(",").length>1) {
          this.parseData(msg.data);
        } else {
          if (msg.data==10) {
            this.$message.success(this.$t('写卡成功'));
          } if (msg.data==11) {
            this.$message.error(this.$t('写卡失败'));
          } if (msg.data==36) {
            this.$message.success(this.$t('阀门卡'));
          } if (msg.data==12) {
            this.$message.warning(this.$t('非本公司卡'));
          }
          this.exhibition=false;
          this.model.cardTypeName=0;
        }
      },
      sClose(e){
        console.log(e);
        console.log("-----接收消息-------" + e.code);
        this.bconn = false;
        this.reconnect();
      },
      reconnect() {
        var that = this;
        if(that.bconn) return;
        //没连接上会一直重连，设置延迟避免请求过多
        this.timeOutId=setTimeout(function () {
          console.info("尝试重连...");
          that.connWebsocket();
        }, 5000);
      },
      querygetCardUserInfo() {  //用户制卡或写卡查询
      console.log(this.arg);
      console.log(this.queryParam);
        let params = {}
        params.cardId = this.model.meterId.slice(2);
        console.log(params);
        getAction(this.url.getCardUserInfo, params).then((res) => {
          if(res.success){
           if (isNull(res.result)) {
             this.disabledRefreshOrderId = false
             this.$message.error(this.$t('该用户未制卡，暂不能用卡充值'));
             console.log("该用户未制卡，暂不能用卡充值");
           } else {
            this.userdate = res.result;
            console.log(this.userdate);
            this.querywriteCard();
           }
          }
        })
      },
      usb_do_deal(mark, socket, flags, wparam){
        // 对数据进行组合
        console.log(wparam);
        var data = flags + "," + mark + "," + wparam;
        socket.send(data);
        console.log(data);
        // this.parseData(data);
      },
      usb_do_checkWebSocket(bconn){
        if(!bconn){
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('写卡器连接错误，请确保插件正常运行后，刷新页面重试!')),
            ]),
            onOk() {},
          });
        }
        return bconn;
      },
      CardInformationOk(e) {
        const that = this;
        setTimeout(() => {
          this.$confirm({
            title: this.$t('立即打印票据吗?'),
            onOk() {
              that.disabledRefreshOrderId = false
              let record = {}
              record.orderId = that.userByKeyId.orderId
              that.$refs.printPayNoteModal.edit(record)
              that.close()
            },
            onCancel() {
              that.disabledRefreshOrderId = false
              that.close()
              console.log('Cancel');
            },
            class: 'test',
          });
        },1000)
      },
      querywriteCard() { 
        // 将写卡记录添加到平台中
      console.log(this.data);
      console.log(this.model);
        let params = {}
        params.userKeyId = this.userdate.userKeyId;
        params.meterId = this.model.meterId;
        params.cardId = this.model.meterId.slice(2);
        params.cardMoney = 0;
        params.buyTimes = this.userdate.userPayTimes;
        params.remainMoney =this.userdate.userAccountNum;
        // 20220606未上报前卡中累计流量不等于起始计费读数问题修改
        //params.sumFlow = this.userdate.userWaterNum;
        params.sumFlow = this.userdate.userCalNum;
        params.waterPrice = this.userdate.wtTotalPrice;
        console.log(params);
        var date = params
        postAction(this.url.writeCard, params).then((res) => {
          if(res.success){
            this.CardInformationOk();
            this.write_card(date);
          }else{
            this.disabledRefreshOrderId = false
            this.$message.error(res.message)
          }
        })
      },
      //写卡
      write_card(data) {
        console.log(data);
        var index='';
        if (this.activeKey==1) {
          index = 60;
        } 
        console.log(parseInt(index));
        switch(parseInt(index))
        {
          case 60:
            //用户卡
            console.log(data);
            let params = '';
            params = data.cardId+','+data.buyTimes+','+data.remainMoney+','+(data.sumFlow*1000).toFixed(0)+','+(data.waterPrice*100).toFixed(0)
            console.log(params);
            this.usb_do_deal(this.wid, this.socket, this.USB_DEF_INDEX.USB_DEF_MAKECARD, params);
            break;
        }
      },
      //
      modalFormOk(){},
      moment,
      handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.queryUserRecordList();
      },
      add () {
        this.edit({});
      },
      edit (record) { 
        console.log(record);
        this.model = Object.assign({}, record);
        this.visible = true;
        console.log(this.model);
        this.queryUserinfo(record);
        this.connWebsocket();
        // this.queryUserByKeyId(record);
      },
      queryUserinfo(record) { //请求用户列表
        let params ={}
        params.meterId = record.meterId
        getAction(this.url.lists, params).then((res) => {
          if (res.success) {
            this.flush = res.result.records[0]
            this.queryUserByKeyId(res.result.records[0]);
            console.log(res.result);
          }
        })
      },
      queryUserByKeyId(records) {  //缴费前查询
      console.log(records);
        let params = {}
        // params.meterId = records.meterId
        params.id = records.id
        putAction(this.url.userByKeyId, params).then((res) => {
          if(res.success){
            console.log(
              res.result
            );
           this.userByKeyId = res.result;
           console.log(this.userByKeyId);
          }
        })
      },
      queryUserRecordList() {  //缴费记录查询
        let params = {}
        params.pageNo = this.ipagination.current;
        params.pageSize = this.ipagination.pageSize;
        params.meterId = this.model.meterId;
        params.userAccountPayType = 1;
        getAction(this.url.UserRecordList, params).then((res) => {
          if(res.success){
           this.data = res.result.records;
           this.ipagination.total = res.result.total;
           console.log(res.result.records);
           console.log(this.ipagination.total);
          }
        })
      },
      handleOk(){
      },
      recharge() {
        if (this.activeKey==1) {
          if(!this.usb_do_checkWebSocket(this.bconn)){
            return;
          }
        }
        const that = this;
        // 计费类型，1为按金额2为按吨数
        if (that.thebillingtype==1) {
          that.$refs.form.validate(valid => {
          if (valid) {
            let str = that.$t('请核对充值金额:{money}元?', { money: that.form.userTotalPayNum });
            that.$confirm({
              title: that.$t('确认缴费?'),
              content: h => <div style="color:red;">{str}</div>,
              onOk() {
                that.disabledRefreshOrderId = true
                console.log('进入缴费');
                that.submitForm();
              },
              onCancel() {
                that.disabledRefreshOrderId = false
              },
              class: 'test',
            });
            // alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        } else {
          that.$refs.form.validate(valid => {
          if (valid) {
            let str = that.$t('请核对实际付款金额:{money}?', { money: that.form.userRealPay });
            that.$confirm({
              title: that.$t('确认缴费?'),
              content: h => <div style="color:red;">{str}</div>,
              onOk() {
                console.log('进入缴费');
                that.submitForm();
              },
              onCancel() {
              },
              class: 'test',
            });
            // alert('submit!');
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        }
      },
      submitForm () {
        // 平台充值
        const that = this;

            let formData = Object.assign({},that.userByKeyId);
            console.log(that.userByKeyId);
            if (that.form.buyWaterCount) {
              formData.buyWaterCount = that.form.buyWaterCount
            } if (that.form.buyWaterMoney) {
              formData.buyWaterMoney = that.form.buyWaterMoney
            } if (that.form.userRealPay) {
              formData.userRealPay = that.form.userRealPay
            } if (that.form.userReturn) {
              formData.userReturn = that.form.userReturn
            } if (that.form.userTotalPayNum) {
              formData.userTotalPayNum = that.form.userTotalPayNum
            } if (that.form.remark) {
              formData.remark = that.form.remark
            }
            formData.payType = that.form.payType
            formData.payWay = that.form .payWay
            console.log("缴费提交数据",formData)
            putAction(that.url.doPayTask,formData).then((res)=>{
              if(res.success&&res.code == 0){
                that.$message.success(res.message);
                  that.querygetCardUserInfo();
                 
              }else{
                that.disabledRefreshOrderId = false
                that.$message.error(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
            that.$refs.form.resetFields();
      },
      callback(key) {
        console.log(key.input);
      },
      userTotalPayNum() {   //充值金额
        if(parseInt(this.form.userTotalPayNum)==0){
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('充值金额不能为0，请重新输入！')),
            ]),
            onOk() {},
          });
          this.form.userTotalPayNum="";
          this.form.buyWaterMoney="";
        }
        if (parseInt(this.form.userTotalPayNum) > parseInt(this.userByKeyId.maxBuyOnce)) {
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('充值金额超过用户单次购买最大金额{max},请重新输入!', { max: this.userByKeyId.maxBuyOnce })),
            ]),
            onOk() {},
          });
          this.form.userTotalPayNum="";
          this.form.buyWaterMoney="";
        } else {
          this.form.buyWaterMoney= this.form.userTotalPayNum    // 充值金额的值给应收金额  
        }
      },
      buyWaterCount(){  //交易吨数
      console.log(this.form.buyWaterCount);
        if(parseInt(this.form.buyWaterCount)==0){
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('交易吨数不能为0，请重新输入！')),
            ]),
            onOk() {},
          });
          this.form.buyWaterCount="";
          this.form.buyWaterMoney="";
        }if (Number(this.form.buyWaterCount*this.userByKeyId.userPriceTotal) > Number(this.userByKeyId.maxHording)) {
          const h = this.$createElement;
          this.$info({
            title: this.$t('信息'),
            content: h('div', {}, [
              h('p', this.$t('交易金额超过用户最大囤积值{max},请重新输入!', { max: this.userByKeyId.maxHording })),
            ]),
            onOk() {},
          });
          this.form.buyWaterCount="";
          this.form.buyWaterMoney="";
        } else {
          this.form.buyWaterMoney = parseFloat(this.form.buyWaterCount*this.userByKeyId.userPriceTotal).toFixed(2)    //应收金额的值*单价
        }
      },
      userRealPay(e){   //实际付款
        console.log(this.form.userRealPay);
        if (this.form.userRealPay!=''&&this.form.userRealPay!=undefined) {
          console.log(e.target.value > this.form.buyWaterMoney);
          console.log(e.target.value);
          console.log(this.form.buyWaterMoney);
          if (parseFloat(e.target.value) >= this.form.buyWaterMoney) {
            this.form.userReturn = parseFloat(e.target.value-this.form.buyWaterMoney).toFixed(2);
          } else{
            const h = this.$createElement;
            this.$info({
              title: this.$t('信息'),
              content: h('div', {}, [
                h('p', this.$t('实际付款金额小于应收金额，请重新输入实际付款！')),
              ]),
              onOk() {},
            });
            this.form.userRealPay="";
            this.form.userReturn="";
          }
        }
      },
      handleChange(row) {   //计费类型点击事件
      this.$nextTick(() => {
          if (this.$refs.form !==undefined) {
            this.$refs.form.clearValidate()
          }
        })
        this.thebillingtype = row.target.value,
        this.form.buyWaterCount='',
        this.form.buyWaterMoney='',
        this.form.remark='',
        this.form.userRealPay='',
        this.form.userReturn='',
        this.form.userTotalPayNum='',
        console.log(row.target.value); 
      },
      amountofmoney(value){  // 金额按钮点击事件
        this.form.userTotalPayNum = value,
        console.log(this.form.userTotalPayNum);
        this.form.buyWaterMoney = value,
        this.$refs.form.validate();
        this.userTotalPayNum();
      },
      Capacity(value) {    //交易吨数按钮点击
        this.form.buyWaterCount = value;
        this.form.buyWaterMoney = value*this.userByKeyId.userPriceTotal;
        this.buyWaterCount();
        this.$refs.form.validate();
      },
      shut(){    //关闭按钮
        this.thebillingtype = '1'
        this.activeKey = '1';
        this.form.payType = 1;
        this.form.payWay = 1;
        this.$refs.form.resetFields();
      },
      close () {
        this.shut();
        this.visible = false;
        clearTimeout(this.timeOutId);
        this.timeOutId = null
        this.socket = null
        this.$emit('ok');
      },
      turnoff(){
        this.shut();
        this.TheUserDetails = false;
      },
      Refresh() {
        this.queryUserByKeyId(this.flush)
      },
      changeTab(e) {
        console.log(e);
        // if (this.activeKey==1) {
        //   this.$refs.form.resetFields();
        // }
        if (this.activeKey == 1) {
          this.connWebsocket();
          
          
        } else {
          this.queryUserRecordList();
        }
      }
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-select{
  width: 100%;
}
.span {
   margin: 8px;
}
.background{
  background-color:rgb(238,238,238)
}
.form-item{
  margin-bottom: 0px;
}
.detail-list >>> .content{
  line-height: normal;
}
#table td{width: 100px;line-height: 50px;text-align: center;}
.label >>> .content{
  color:red;
}
</style>